import AdminPageTitle from "../../components/admin-page-title";
import { BiPlus } from "react-icons/bi";
import { useEffect, useState } from "react";
import {
  AiFillDelete,
  AiFillEdit,
  AiFillEye,
  AiFillEyeInvisible,
} from "react-icons/ai";
import FileUploader from "../../components/file-uploader";
import { OffreService } from "../../service/offre.service";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
// Ant Design imports
import {
  Button,
  Modal,
  Table,
  Form,
  Input,
  Select,
  Checkbox,
  InputNumber,
  Upload,
  message,
} from "antd";

const { Option } = Select;

const FORM_IS = {
  id: undefined,
  title_fr: "",
  title_ar: "",
  title_en: "",
  content_fr: "",
  content_ar: "",
  content_en: "",
  contenu_fr: "",
  contenu_ar: "",
  contenu_en: "",
  image: "",
  banner: "",
  type: "general",
  is_active: true,
  display_order: 0,
};

export default function GestionOffres() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(FORM_IS);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [formInstance] = Form.useForm();

  // React Quill configuration
  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ color: [] }, { background: [] }],
      ["link", "image"],
      ["clean"],
    ],
  };

  const quillFormats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "color",
    "background",
    "link",
    "image",
  ];

  useEffect(() => {
    getAll();
  }, []);

  const onEditClicked = (row) => {
    setForm({ ...row });
    formInstance.setFieldsValue({ ...row });
    setModalVisible(true);
  };

  const onAddClicked = () => {
    resetForm();
    setModalVisible(true);
  };

  const postEntity = () => {
    setLoading(true);
    OffreService.create(form)
      .then(() => {
        getAll();
        setLoading(false);
        setModalVisible(false);
        resetForm();
        message.success("Offre créée avec succès");
      })
      .catch((error) => {
        console.error("Error creating offer:", error);
        setLoading(false);
        message.error("Erreur lors de la création de l'offre");
      });
  };

  const putEntity = () => {
    setLoading(true);
    OffreService.update(form.id, form)
      .then(() => {
        setLoading(false);
        setModalVisible(false);
        resetForm();
        getAll();
        message.success("Offre modifiée avec succès");
      })
      .catch((error) => {
        console.error("Error updating offer:", error);
        setLoading(false);
        message.error("Erreur lors de la modification de l'offre");
      });
  };

  const deleteEntity = (id) => {
    Modal.confirm({
      title: "Êtes-vous sûr de vouloir supprimer cette offre ?",
      onOk: () => {
        OffreService.delete(id).then(() => {
          getAll();
          message.success("Offre supprimée");
        });
      },
    });
  };

  const toggleStatus = (id) => {
    const offre = rows.find((r) => r.id === id);
    OffreService.update(id, { ...offre, is_active: !offre.is_active }).then(
      () => getAll()
    );
  };

  const submit = () => {
    if (!form.title_fr.trim()) {
      message.warning("Le titre français est requis");
      return;
    }
    if (!form.image.trim()) {
      message.warning("L'image principale est requise");
      return;
    }
    if (form.id) {
      putEntity();
    } else {
      postEntity();
    }
  };

  const resetForm = () => {
    setForm({ ...FORM_IS });
    formInstance.resetFields();
  };

  const getAll = () => {
    OffreService.getAll().then((res) => {
      setRows(res.data || []);
    });
  };

  const handleFormChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    formInstance.setFieldsValue({ [field]: value });
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (img, row) =>
        img ? (
          <img
            src={img}
            alt={row.title_fr}
            style={{ width: 50, height: 50, objectFit: "cover" }}
          />
        ) : null,
    },
    {
      title: "Titre",
      dataIndex: "title_fr",
      key: "title_fr",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (type) => (
        <span style={{ color: type === "accommodation" ? "#1890ff" : "#888" }}>
          {type === "accommodation" ? "Hébergement" : "Général"}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      render: (is_active, row) => (
        <Button
          type={is_active ? "primary" : "default"}
          size="small"
          onClick={() => toggleStatus(row.id)}
          icon={is_active ? <AiFillEye /> : <AiFillEyeInvisible />}
        />
      ),
    },
    {
      title: "Ordre",
      dataIndex: "display_order",
      key: "display_order",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, row) => (
        <>
          <Button
            type="default"
            size="small"
            icon={<AiFillEdit />}
            onClick={() => onEditClicked(row)}
            style={{ marginRight: 8 }}
          />
          <Button
            type="primary"
            danger
            size="small"
            icon={<AiFillDelete />}
            onClick={() => deleteEntity(row.id)}
          />
        </>
      ),
    },
  ];

  return (
    <div>
      <AdminPageTitle title="Gestion des Offres" />
      <div
        style={{
          marginBottom: 16,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h5 style={{ margin: 0 }}>Liste des Offres</h5>
        <Button type="primary" icon={<BiPlus />} onClick={onAddClicked}>
          Ajouter une offre
        </Button>
      </div>
      <Table
        dataSource={rows}
        columns={columns}
        rowKey="id"
        pagination={{ pageSize: 10 }}
      />
      <Modal
        title={form.id ? "Modifier l'offre" : "Ajouter une offre"}
        open={modalVisible}
        onCancel={() => {
          resetForm();
          setModalVisible(false);
        }}
        onOk={submit}
        confirmLoading={loading}
        okText={form.id ? "Modifier" : "Enregistrer"}
        cancelText="Fermer"
        width={900}
      >
        <form onSubmit={(e) => { e.preventDefault(); submit(); }}>
          <div style={{ display: "flex", gap: 16 }}>
            <div style={{ flex: 1 }}>
              <label>Titre (Français) *</label>
              <Input
                value={form.title_fr}
                onChange={(e) => handleFormChange("title_fr", e.target.value)}
                required
              />
            </div>
            <div style={{ flex: 1 }}>
              <label>Titre (Arabe)</label>
              <Input
                value={form.title_ar}
                onChange={(e) => handleFormChange("title_ar", e.target.value)}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label>Titre (Anglais)</label>
              <Input
                value={form.title_en}
                onChange={(e) => handleFormChange("title_en", e.target.value)}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label>Type</label>
              <Select
                value={form.type}
                onChange={(value) => handleFormChange("type", value)}
                style={{ width: "100%" }}
              >
                <Option value="general">Général</Option>
                <Option value="accommodation">Hébergement</Option>
              </Select>
            </div>
          </div>
          <div style={{ display: "flex", gap: 16, marginTop: 16 }}>
            <div style={{ flex: 1 }}>
              <label>Contenu (Français)</label>
              <Input.TextArea
                rows={4}
                value={form.content_fr}
                onChange={(e) => handleFormChange("content_fr", e.target.value)}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label>Contenu (Arabe)</label>
              <Input.TextArea
                rows={4}
                value={form.content_ar}
                onChange={(e) => handleFormChange("content_ar", e.target.value)}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label>Contenu (Anglais)</label>
              <Input.TextArea
                rows={4}
                value={form.content_en}
                onChange={(e) => handleFormChange("content_en", e.target.value)}
              />
            </div>
          </div>
          <div style={{ marginBottom: 16, marginTop: 16 }}>
            <h6 style={{ color: "#1890ff" }}>Contenu Riche (React Quill)</h6>
          </div>
          <div style={{ display: "flex", gap: 16, marginBottom: 24 }}>
            <div style={{ flex: 1 }}>
              <label>Contenu Riche (Français)</label>
              <ReactQuill
                theme="snow"
                value={form.contenu_fr}
                onChange={(value) => handleFormChange("contenu_fr", value)}
                modules={quillModules}
                formats={quillFormats}
                style={{ height: "200px", marginBottom: "30px" }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label>Contenu Riche (Arabe)</label>
              <ReactQuill
                theme="snow"
                value={form.contenu_ar}
                onChange={(value) => handleFormChange("contenu_ar", value)}
                modules={quillModules}
                formats={quillFormats}
                style={{ height: "200px", marginBottom: "30px" }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label>Contenu Riche (Anglais)</label>
              <ReactQuill
                theme="snow"
                value={form.contenu_en}
                onChange={(value) => handleFormChange("contenu_en", value)}
                modules={quillModules}
                formats={quillFormats}
                style={{ height: "200px", marginBottom: "30px" }}
              />
            </div>
          </div>
          <div style={{ marginBottom: 16 }}>
            <label>Image Principale *</label>
            <FileUploader
              id="image-uploader"
              onUrlReceived={(url) => handleFormChange("image", url)}
              onClickArea={() => {}}
              html={
                <div
                  style={{
                    height: 200,
                    width: "100%",
                    border: form.image
                      ? "1px solid lightgray"
                      : "2px dashed #1890ff",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (typeof window !== 'undefined' && document) {
                      const uploader = document.getElementById('image-uploader');
                      if (uploader) {
                        uploader.click();
                      }
                    }
                  }}
                >
                  {form.image !== "" ? (
                    <img
                      src={form.image}
                      height="100%"
                      width="100%"
                      alt=""
                      style={{ objectFit: "cover" }}
                    />
                  ) : (
                    <span style={{ color: "#1890ff", fontSize: "2rem" }}>
                      + Image Principale
                    </span>
                  )}
                </div>
              }
            />
          </div>
          <div style={{ display: "flex", gap: 16 }}>
            <div style={{ flex: 1 }}>
              <label>Ordre d'affichage</label>
              <InputNumber
                min={0}
                style={{ width: "100%" }}
                value={form.display_order}
                onChange={(value) => handleFormChange("display_order", value || 0)}
              />
            </div>
            <div style={{ flex: 1, marginTop: 32 }}>
              <Checkbox
                checked={form.is_active}
                onChange={(e) => handleFormChange("is_active", e.target.checked)}
              >
                Actif
              </Checkbox>
            </div>
          </div>
          
        </form>
      </Modal>
    </div>
  );
}
